<div class="mb-searchbar-group clearfix" [ngStyle]="{'height': isCard ? '100%' : 'auto'}">
  <div class="mb-sidepanel-mobile" title="Show menu">
      <!-- <span><a href="javascript:void(0)" (click)="ShowToDo()">&#187;</a></span> -->
  </div>
  <div class="searchBarPanel">
    <div class="input-group" style="width: 98%;margin: 0 'auto';">
        <input #text type="text" [value]="keyword" id="search" class="form-control" placeholder="What would you like to do today?" (keyup.enter)="searchByKeyword(text.value)">
        <span class="input-group-addon search-addon">
            <a *ngIf="speechApi && !isBusy" id="microfon-ic" (click)="activateSpeech()">
                <img src="../../assets/images/microfon.png" />
            </a>
            <a *ngIf="!isBusy" id="search-ic" (click)="searchByKeyword(text.value)">
                <img src="../../assets/images/search.png" />
            </a>
            <div *ngIf="isBusy" class="spinner spinner-input">
                <div class="bounce1"></div>
                <div class="bounce2"></div>
                <div class="bounce3"></div>
            </div>
        </span>
    </div>
  </div>
</div>